import { useState, useEffect } from "react";
import { Pipeline } from "@/types/pipeline";
import { pipelineAPI } from "@/services/pipelineService";
import { useAuth } from "./useAuth";

export function usePipelines() {
  const { company } = useAuth();
  const [pipelines, setPipelines] = useState<Pipeline[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPipelines = async () => {
    if (!company?.slug) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await pipelineAPI.getPipelines({
        slug: company.slug,
        is_active: true,
      });

      if (response.success && response.data) {
        setPipelines(response.data);
      } else {
        setPipelines([]);
      }
    } catch (err) {
      console.error("Error fetching pipelines:", err);
      setError("Error al cargar los pipelines");
      setPipelines([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPipelines();
  }, [company?.slug]);

  return {
    pipelines,
    loading,
    error,
    refetch: fetchPipelines,
  };
}
